import { render, staticRenderFns } from "./baseInfoDetail.vue?vue&type=template&id=a12792ae&scoped=true&"
import script from "./baseInfoDetail.vue?vue&type=script&lang=js&"
export * from "./baseInfoDetail.vue?vue&type=script&lang=js&"
import style0 from "./baseInfoDetail.vue?vue&type=style&index=0&id=a12792ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12792ae",
  null
  
)

export default component.exports